import type { ReactNode } from 'react'

import { cn } from '@/_lib/utils'
import { Container } from './container'
import { Title } from './typography'

interface PageLayoutProps {
  title: string
  toolbar?: ReactNode
  actions?: ReactNode
  filters?: ReactNode
  children: ReactNode
  className?: string
  fullBleedContent?: boolean
}

export function PageLayout({
  title,
  toolbar,
  actions,
  filters,
  children,
  className,
  fullBleedContent,
}: PageLayoutProps) {
  return (
    <Container
      className={cn('h-full gap-6 py-10', fullBleedContent ? 'px-0 pb-0' : 'px-14', className)}
    >
      <div className={cn('flex w-full flex-col gap-6', fullBleedContent && 'px-14')}>
        <div className="flex h-10 w-full items-center justify-between">
          <div className="flex items-center gap-4">
            <Title>{title}</Title>
            {toolbar && <div className="flex items-center gap-2">{toolbar}</div>}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>

        {filters}
      </div>

      {children}
    </Container>
  )
}
